
import Tether from "../../../assets/outline/Tether.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TetherIcon({ className, dataTestid = "TetherIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Tether data-testid={dataTestid} className={classes} {...rest} />
  );
}
